module.exports = __webpack_public_path__ + "img/微信图片_20200402154627.c2e0b61d.png";